import { AbstractControl } from "@angular/forms";

// australia-states.ts
export const AUSTRALIA_STATES = [
    { label: 'New South Wales(NSW)', value: 'NNew South WalesSW' },
    { label: 'Victoria(VIC)', value: 'Victoria' },
    { label: 'Queensland(QLD)', value: 'Queensland' },
    { label: 'Western Australia(WA)', value: 'Western Australia' },
    { label: 'South Australia(SA)', value: 'South Australia' },
    { label: 'Tasmania(TAS)', value: 'Tasmania' },
    { label: 'Northern Territory(NT)', value: 'Northern Territory' },
    { label: 'Australian Capital Territory(ACT)', value: 'Australian Capital Territory' }
];

// export function requiredTrimmed(control: AbstractControl) {
//   const value = control.value;
//   return value && value.trim().length > 0
//     ? null
//     : { required: true };
// }
// ss_c_17012026-fixed trim issue in console

export function requiredTrimmed(control: AbstractControl) {
  const value = control.value;

  // null or undefined
  if (value === null || value === undefined) {
    return { required: true };
  }

  // string input
  if (typeof value === 'string') {
    return value.trim().length > 0 ? null : { required: true };
  }

  // array (multi-select)
  if (Array.isArray(value)) {
    return value.length > 0 ? null : { required: true };
  }

  // object (dropdown option)
  if (typeof value === 'object') {
    return Object.keys(value).length > 0 ? null : { required: true };
  }

  return null;
}

export function removePageParam(url: string): string {
  const [base, query] = url.split('?');
  if (!query) return url;
  
  const params = new URLSearchParams(query);
  params.delete('page');
  
  const queryString = params.toString();
  return queryString ? `${base}?${queryString}` : base;
  // return url;
}

const isDDMMYYYY = (value: any): boolean => {
  return typeof value === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(value);
};

export function parseDDMMYYYY(dateStr: string) {
  if (!isDDMMYYYY(dateStr)) return null;
  
  const [day, month, year] = dateStr.split('/').map(Number);
  const date = new Date(year, month - 1, day);
   
  if (
    date.getFullYear() !== year ||
    date.getMonth() !== month - 1 ||
    date.getDate() !== day
  ) {
    return null;
  }
  
  return date.getTime();
};

export function sortedData(data: any[],sortDirection: 'asc' | 'desc' | '',sortColumn: string | null){
  return data.sort((a, b) => {
    let aVal = a[sortColumn!];
    let bVal = b[sortColumn!];
    
    if (aVal == null && bVal == null) return 0;
    if (aVal == null) return 1;
    if (bVal == null) return -1;
    
    if (
      typeof aVal === 'object' &&
      typeof bVal === 'object' &&
      aVal?.date &&
      bVal?.date
    ) {
      const aDate = parseDDMMYYYY(aVal.date);
      const bDate = parseDDMMYYYY(bVal.date);
      
      if (aDate != null && bDate != null) {
        return sortDirection === 'asc'
        ? aDate - bDate
        : bDate - aDate;
      }
      
      return 0;
    }
    
    const aNum = typeof aVal === 'number' ? aVal : Number(aVal);
    const bNum = typeof bVal === 'number' ? bVal : Number(bVal);
    
    if (!isNaN(aNum) && !isNaN(bNum)) {
      return sortDirection === 'asc'
      ? aNum - bNum
      : bNum - aNum;
    }
    
    if (typeof aVal === 'object' || typeof bVal === 'object') {
      return 0;
    }
    
    const aStr = String(aVal).toLowerCase();
    const bStr = String(bVal).toLowerCase();
    
    if (aStr < bStr) return sortDirection === 'asc' ? -1 : 1;
    if (aStr > bStr) return sortDirection === 'asc' ? 1 : -1;
    
    return 0;
  });
}